import { useSelector } from 'react-redux';
import { t } from '../i18n';

function useTranslation() {
  const locale = useSelector((state) => state.language.locale);

  const translate = (key) => {
    return t(key, locale);
  };

  return { t: translate };
}

export default useTranslation;
